module.exports = __webpack_public_path__ + "img/10.aa9eadf9.gif";